import { z } from "zod";
import { surfaceEnvelope } from "./shared";

export const HomeConversationSchema = z
  .object({
    id: z.string(),
    conversation_title: z.string().nullish(),
    topic: z.string(),
    site: z.string(),
    estimated_tokens: z.number(),
    last_captured_at: z.string(),
    project_name: z.string().nullish(),
  })
  .passthrough();

export const HomeSurfaceDataSchema = z
  .object({
    recent_conversations: z.array(HomeConversationSchema).default([]),
    conversations_this_week: z.number(),
    tokens_this_week: z.number(),
    total_projects: z.number(),
    sources_connected: z.number(),
  })
  .passthrough();

export const HomeSurfaceResponseSchema = surfaceEnvelope(HomeSurfaceDataSchema);

export type HomeConversation = z.infer<typeof HomeConversationSchema>;
export type HomeSurfaceData = z.infer<typeof HomeSurfaceDataSchema>;
export type HomeSurfaceResponse = z.infer<typeof HomeSurfaceResponseSchema>;
